module.exports = __webpack_public_path__ + "img/gender-queer.ffe44de6.png";